import React, { useCallback, createContext } from "react";
import PropTypes from "prop-types";
import { makeStyles, styled } from "@material-ui/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Provider, createStoreHook, createDispatchHook, createSelectorHook } from "react-redux";
import WebIM, { initIMSDK } from "../utils/WebIM";
import store from "../redux/index";
import GlobalPropsActions from "../redux/globalProps";
import createlistener from "../utils/WebIMListen";
import MessageActions from "../redux/message";
import SessionActions from "../redux/session";
import _ from "lodash";
import "../i18n";
import "../common/iconfont.css";
import SessionList from "../EaseChat/session/sessionList";
import EaseChat from "../EaseChat/chat/index";
var uikit_store = React.createContext();
export var useDispatch = createDispatchHook(uikit_store);
export var useSelector = createSelectorHook(uikit_store);
export var EaseAppContext = createContext();
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      height: "100%",
      display: "flex"
    },
    grid: {
      backgroundColor: "rgba(206, 211, 217, 0.3)"
    }
  };
});
var Item = styled(Grid)(function (_ref) {
  var theme = _ref.theme;
  return {};
});

var EaseApp = function EaseApp(props) {
  var dispatch = useDispatch(null);
  var classes = useStyles();
  var handleClickItem = useCallback(function (session) {
    props.onConversationClick && props.onConversationClick(session);
    var sessionType = session.sessionType,
        sessionId = session.sessionId;

    if (!session.lastMessage) {
      dispatch(MessageActions.fetchMessage(sessionId, sessionType));
    }

    dispatch(GlobalPropsActions.setGlobalProps({
      to: sessionId,
      chatType: sessionType
    }));
    dispatch(SessionActions.setCurrentSession(sessionId));
    dispatch(MessageActions.clearUnreadAsync(sessionType, sessionId));
  }, [props.width]);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      position: "absolute",
      width: "100%",
      height: "calc(100%)"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    item: true,
    xs: 6,
    md: 3,
    className: classes.grid
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement("div", null, props.header), /*#__PURE__*/React.createElement(EaseAppContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(SessionList, {
    onClickItem: handleClickItem
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 9
  }, /*#__PURE__*/React.createElement(EaseChat, props))));
};

var EaseAppProvider = function EaseAppProvider(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    context: uikit_store,
    store: store
  }, /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(EaseApp, props)));
};

export default EaseAppProvider;

EaseAppProvider.addConversationItem = function (session) {
  if (session && Object.keys(session).length > 0) {
    var conversationType = session.conversationType,
        conversationId = session.conversationId;
    var dispatch = store.dispatch;
    var storeSessionList = store.getState().session;
    var sessionList = storeSessionList.sessionList;

    var isNewSession = _.findIndex(sessionList, function (v) {
      return v.sessionId === session.conversationId;
    });

    if (isNewSession === -1) {
      dispatch(SessionActions._pushSession({
        sessionType: session.conversationType,
        sessionId: session.conversationId
      }));
    }

    dispatch(SessionActions.setCurrentSession(conversationId));
    dispatch(SessionActions.topSession(conversationId, conversationType));
    dispatch(GlobalPropsActions.setGlobalProps({
      to: conversationId,
      chatType: conversationType
    }));
    dispatch(MessageActions.clearUnreadAsync(conversationType, conversationId));
  }
};

EaseAppProvider.getSdk = function (props) {
  if (!WebIM.conn) {
    initIMSDK(props.appkey);
    createlistener(props);
  }

  return WebIM;
};

EaseAppProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  username: PropTypes.string,
  agoraToken: PropTypes.string,
  appkey: PropTypes.string,
  header: PropTypes.node,
  addConversationItem: PropTypes.func,
  isShowUnread: PropTypes.bool,
  unreadType: PropTypes.bool,
  onConversationClick: PropTypes.func,
  showByselfAvatar: PropTypes.bool,
  easeInputMenu: PropTypes.string,
  menuList: PropTypes.array,
  handleMenuItem: PropTypes.func
} : {};
EaseAppProvider.defaultProps = {
  isShowUnread: true,
  unreadType: true
};